import React from "react";
import { InputField } from "../../../lib";
import { useEffect } from "react";
import { useFormikContext } from "formik";
import { FieldsContainer } from "src/styles/Containers";

function AddBehaviorCategoryFields() {
  const formikProps = useFormikContext();
  const [focus, setFocus] = React.useState(true);

  useEffect(() => {
    formikProps.setTouched({});
    setFocus(false);
  }, []);

  return (
    <FieldsContainer>
      <InputField
        placeholder={"Behavior Category *"}
        name={"name"}
        inputRef={(input: any) => (focus ? input && input.focus() : null)}
        onFocus={(e: any) => {
          e.currentTarget.setSelectionRange(
            e.currentTarget.value.length,
            e.currentTarget.value.length
          );
        }}
      />
    </FieldsContainer>
  );
}

export default AddBehaviorCategoryFields;
